import React, { useMemo } from "react";
import { useDispatch } from "react-redux";

import { IgButton, IgTypography } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";
import { useConfiguration } from "@src/api/configurations/use-configuration";
import { useGetExperiencesList } from "@src/api/experiences-list/get-experiences-list";
import { useGetOrg } from "@src/api/organizations/get-organization";
import { useLoggedInUser } from "@src/api/user-auths/login";
import { CreateExperimentDialog } from "@src/components/Dialogs/CreateExperimentDialog";
import { UserInfoPopup } from "@src/components/Dialogs/UserInfoPopup";
import Community from "@src/components/MainApp/Utils/Community";
import { Resources } from "@src/components/MainApp/Utils/Resources";
import { OffersMarketingBanner } from "@src/components/OffersMarketingBanner";
import { IgErrorBoundary } from "@src/components/Utils/IgErrorBoundary";
import { getRunningExperiences } from "@src/domains/HomeDashboard/components/utils";
import { OfferLimitReachedDialog } from "@src/features/sharedExperience/components/alertsAndWarnings/OfferLimitReachedDialog";
import { useRouteTiming } from "@src/hooks/timing";
import { setDialog } from "@src/store/slices/global";
import Loading from "@src/utils/Loading";

import { ActiveTestSection } from "./components/ActiveTest/ActiveTestSection";
import { OnboardingTestFlowHelper } from "./components/OnboardingTestFlowHelper";

export const HomeDashboard = () => {
  const dispatch = useDispatch();
  const organization = useGetOrg();
  const user = useLoggedInUser();

  const selectedTestType = useConfiguration<string>("onboarding_test_flow");

  const experiencesList = useGetExperiencesList({ category: "experiment" });
  const campaigns = useGetExperiencesList({ category: "personalization" });

  const shouldRenderOnboardingHelper = useMemo(() => {
    if (campaigns.isSuccess && experiencesList.isSuccess) {
      return (
        experiencesList.data.experiencesList.filter(
          (exp) => exp.status !== "pending"
        ).length === 0 &&
        campaigns.data.experiencesList.filter(
          (campaign) => campaign.startedAtTs
        ).length === 0
      );
    } else return false;
  }, [experiencesList, campaigns, selectedTestType, user]);

  useRouteTiming({
    page: "home",
    isReady: experiencesList.isSuccess && user.isSuccess,
  });

  if (user.isSuccess) {
    return (
      <IgErrorBoundary>
        {/*<UserInfoPopup />*/}
        <CreateExperimentDialog />
        <OfferLimitReachedDialog />
        <Grid item mb={8}>
          <OffersMarketingBanner />
        </Grid>
        <Grid container direction={"column"} rowSpacing={4}>
          <Grid
            container
            item
            direction={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
            xs={8}
            flexWrap={"nowrap"}
          >
            <Grid item xs={8}>
              <IgTypography variant={"h1"} fontWeight={"fontWeightMedium"}>
                Welcome, {organization.data.org.name}!
              </IgTypography>
            </Grid>
            <Grid container item columnSpacing={2} justifyContent={"end"}>
              {/*<Grid item>*/}
              {/*  <TestIdeasAiButton />*/}
              {/*</Grid>*/}
              <Grid item>
                <IgButton
                  onClick={() => {
                    dispatch(
                      setDialog({ dialog: "createExperiment", open: true })
                    );
                  }}
                  variant={"contained"}
                >
                  Create New Test
                </IgButton>
              </Grid>
            </Grid>
          </Grid>
          {shouldRenderOnboardingHelper && (
            <Grid item>
              <OnboardingTestFlowHelper />
            </Grid>
          )}

          {getRunningExperiences(
            experiencesList.data?.experiencesList || [],
            false
          ).length > 0 && (
            <Grid item xs={12}>
              <ActiveTestSection
                activeExperiences={getRunningExperiences(
                  experiencesList.data?.experiencesList || [],
                  false
                )}
              />
            </Grid>
          )}
          {/* <Grid item>
            <Community />
          </Grid> */}
          <Grid item>
            <Resources />
          </Grid>
        </Grid>
      </IgErrorBoundary>
    );
  }

  return (
    <Grid container direction={"row"}>
      <Grid item>
        <Loading centered={true} />
      </Grid>
    </Grid>
  );
};
